import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import employeesHeaders from "@/pages/Maintenance/Employees/employeesHeaders";

export default {
	state: {
		employeesItem: null,
		customersMod: null,
		employeesAll: null,
		employeesList: null,
		employeesFilters: null,
		employeesTotals: null,
		employeesLimit: null,
		employeesOrder: null,
		employeesSort: null,
		employeesTotal: null,
		settingsEmployeesInventory: null,
		itemsEmployeesInventory: null,
		filtersEmployeesInventory: null,
	},
	mutations: {
		updateEmployeesList(state, { rows, limit, order, sort, total }) {
			state.employeesList = rows;
			state.employeesLimit = limit;
			state.employeesOrder = order;
			state.employeesSort = sort;
			state.employeesTotal = total;
			state.employeesTotals = { name: total };
		},
		updateEmployeesFilters(state, { filter }) {
			state.employeesFilters = filter;
		},
		updateEmployees(state, payload) {
			console.log('%c [  payload  ] ', 'color:#bada55', typeof payload, payload );
			console.log('%c [  payload.employeesAll  ] ', 'color:#bada55', typeof payload.employeesAll, payload.employeesAll );
			state.employeesItem = payload;
			state.customersMod = payload.customers.slice(1);
			state.employeesAll = payload.employeesAll;
		},
		updateEmployeesInventory(state, { settings, items, filters }) {
			state.settingsEmployeesInventory = settings;
			state.itemsEmployeesInventory = items;
			state.filtersEmployeesInventory = filters;
		},
	},
	actions: {

		async deleteEmployeesDocuments({ dispatch }, values) {
			console.info('%c [  dispatch  ] ', 'color:#bada55', typeof dispatch, dispatch );
			try {
				const { id } = values;
				const { data } = await httpClient.delete(`info/documents/${ id }`);
				if (data && data.status) {
					// ===== Заменеить на обновленеи списка инверторя =====
					// dispatch('getEmployeesInventoryList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async deleteEmployeesInventory({ dispatch }, values) {
			try {
				const { id, employeeId } = values;
				const { data } = await httpClient.delete(`/employees/${ employeeId }/inventory/${ id }`);
				if (data && data.status) {
					// ===== Заменеить на обновленеи списка инверторя =====
					dispatch('getEmployeesInventoryList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getEmployeesInventoryList({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { employeeId } = values;
				const { data } = await httpClient.get(`/employees/${ employeeId }/inventory/`);
				if (data) {
					commit('updateEmployeesInventory', data);
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getEmployees({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/employees/list', values);

				if (data && !data.status) {
					commit('updateEmployeesList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.TRUCKS, defaultHeader: employeesHeaders });
					// commit('updateSettings', { settings: [], key: requestKeys.TRUCKS, defaultHeader: employeesHeaders });
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getEmployeesFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/employees/filters', values);
				if (data) commit('updateEmployeesFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async onEmployeesSave({ dispatch }, { values, id }) {
			dispatch("actionPreloader", true);
			const typeOfRequest = id ? 'put' : 'post';
			const url = id ? `/employees/${ id }` : '/employees';
			try {
				const { data } = await httpClient[typeOfRequest](url, values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async onEmployeesRemoveItem({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.delete(`/employees/${ id }`);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "The removal was successful" });
				} else {
					dispatch('setAlert', { type: "error", message: "Deletion error" });
				}

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onEmployees({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const uri = id ? `/employees/${ id }/edit` : '/employees/create';
				const { data } = await httpClient.get(uri);

				if (data && !data.status) {
					commit('updateEmployees', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
	},
	getters: {
		employeesItem: (s) => s.employeesItem,
		customersMod: (s) => s.customersMod,
		employeesAll: (s) => s.employeesAll,
		employeesList: (s) => s.employeesList,
		employeesFilters: (s) => s.employeesFilters,
		employeesTotals: (s) => s.employeesTotals,
		employeesLimit: (s) => s.employeesLimit,
		employeesOrder: (s) => s.employeesOrder,
		employeesSort: (s) => s.employeesSort,
		employeesTotal: (s) => s.employeesTotal,
		settingsEmployeesInventory: (s) => s.settingsEmployeesInventory,
		itemsEmployeesInventory: (s) => s.itemsEmployeesInventory,
		filtersEmployeesInventory: (s) => s.filtersEmployeesInventory,
	}
};
